import type { Icon } from '../../../src/lib/types'
export const mdiMenu: Icon = {
  "id": "menu",
  "name": "Menu",
  "path": "M3,6H21V8H3V6M3,11H21V13H3V11M3,16H21V18H3V16Z",
  "as": [
    "hamburger-menu"
  ],
  "tags": []
}
export default mdiMenu